import styled from 'styled-components';
import Link from 'next/link';

import { t } from 'localization/utils/t';
import { APP_DOWNLOAD_LINK_APP_PAGE } from '../enums/appLandingPageEnums';

const TP = 'appLanding.components.iosCta';

export const IosCta = ({ link }: { link?: string }) => (
  <Link
    href={link || APP_DOWNLOAD_LINK_APP_PAGE}
    aria-label={t(`${TP}.downloadGoatApp`, 'Download the GOAT App')}
  >
    <IosCta.Img
      data-qa="ios_download_app"
      src="https://cms-cdn.goat.com/3000/4af4d5d1b03c-c098-0f11-634c-0fb47327.png"
      alt={t(`${TP}.appStoreCta`, 'App Store CTA')}
    />
  </Link>
);

IosCta.Img = styled.img`
  height: 32px;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    height: 40px;
  }
`;
